<template>
    <div>
        <div style="width: 300px;height: 300px;">
            <img v-if="wxQrCodeImg" :src="wxQrCodeImg" width="300" height="300" />
        </div>
    </div>
</template>
<script>
import api from '@/api/api'
import { sendConvertData } from '@/utils/baidu'
export default {
    data() {
        return {
            times: 1000,
            wxQrCodeImg: '',
            sceneId: ''
        }
    },
    created() {
        this.getWxQRCodeImg()
    },
    beforeDestroy() {
        clearInterval(this.typingTimer)
    },
    methods: {
        getWxQRCodeImg() {
            api.getWxQRCodeImg().then(res => {
                if (res.code === 200) {
                    let { url, sceneId, expireSeconds } = res.data
                    this.wxQrCodeImg = url
                    this.sceneId = sceneId
                    this.times = expireSeconds
                    if (this.typingTimer) {
                        clearInterval(this.typingTimer);
                    }
                    this.typingTimer = setInterval(() => {
                        this.WxQRCodeLogin()
                    }, this.times);
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        WxQRCodeLogin() {
            api.WxQRCodeLogin({ sceneId: this.sceneId }).then(res => {
                if (res.code === 200) {
                    let { token } = res.data
                    //有toke 说明用户已经扫码关注成功
                    if (token) {
                        //登录成功清除倒计时
                        clearInterval(this.typingTimer)
                        this.$message.success('登录成功')
                        localStorage.setItem('token_key', token)
                        api.getUserinfo().then(res1 => {
                            if (res1.code === 200) {
                                if (!res1.data.signIn) {
                                    api.setUserLoginState({ id: res1.data.id }).then(res2 => {
                                        const conversionTypes = {
                                            logidUrl: localStorage.getItem('logidUrl'),
                                            newType: 25,
                                            deviceType: 2
                                        }
                                        sendConvertData(conversionTypes).then(result => {
                                            console.log('调用转化成功=', result)
                                            window.location.reload()
                                            this.close()
                                        }).catch((err) => {
                                            console.log('调用转化失败=', err)
                                        })
                                    })
                                } else {
                                    window.location.reload()
                                    this.close()
                                }
                            }
                        })
                    }
                }
            })
        }
    }
}
</script>